import { useEffect, useMemo } from "react";
import { _ } from "@sablier/v2-mixins";

export default function useScrollDisable(
  condition = false,
  element: HTMLElement | undefined = undefined,
) {
  const resolved = useMemo(() => {
    if (!_.isWindow() || !document) {
      return undefined;
    }
    if (!element) {
      return document.scrollingElement as HTMLElement;
    }

    return element;
  }, [element]);

  useEffect(() => {
    if (!resolved) {
      return;
    }

    if (condition) {
      resolved.style.overflow = "hidden";
    }

    return () => {
      resolved.style.overflow = "auto";
    };
  }, [condition, resolved]);
}
